import gql from 'graphql-tag'

export const GET_SCHEDULERS = gql`
  query ReportSchedulers($filter: GetReportSchedulerFilter) {
    reportSchedulers(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportSchedulers {
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        data {
          aggregate {
            whatsapp
            email
          }
          reportSchedulerId
          companyId
          userId
          scheduleName
          reportName
          period
          periodLabel
          noOfDay
          time
          recipients
          filter
          canDelete
          title
          body
          startTime
          endTime
          isActive
          reportSchedulerContent {
            reportSchedulerId
            contentId
            contentType
          }
        }
      }
    }
  }
`

export const DELETE_SCHEDULER = gql`
  mutation DeleteReportScheduler($input: DeleteReportSchedulerInput) {
    deleteReportScheduler(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportScheduler {
        reportSchedulerId
        companyId
        userId
        scheduleName
        reportName
        period
        periodLabel
        noOfDay
        time
        recipients
        filter
        canDelete
        title
        body
        startTime
        endTime
        isActive
      }
    }
  }
`

export const SEND_REPORT_HTML = gql`
  mutation SendReportHtml($input: GetReportHtmlFilter!) {
    sendReportHtml(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const UPDATE_STATUS_SCHEDULER = gql`
  mutation UpdateReportScheduler($input: UpdateReportSchedulerInput!) {
    updateReportScheduler(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateReportScheduler {
        reportSchedulerId
        companyId
        userId
        scheduleName
        reportName
        period
        periodLabel
        noOfDay
        time
        recipients
        filter
        canDelete
        title
        body
        startTime
        endTime
        isActive
      }
    }
  }
`
